import { create } from 'zustand';

export type User = {
      id?: number;
      fullName?: string;
      email?: string;
      countryCode?: string;
      phone?: string;
      rolename?: string;
      status?: boolean;
      createdAt?: number;
      updatedAt?: number;
};

export type Status = {
      id: number;
      name: string;
      sequence: number;
      type: "External" | "Internal";
      createdAt: number;
      updatedAt: number;
      parent_id: null | number;
      active: number;
      children: Status[];
};

export type Verifier = {
      id: number;
      fullName: string;
      email: string;
      rolename: string;
}

interface UserState {
      user: User | null;
      status: Status[] | null;
      verifiers: Verifier[] | null;
      statusFlatMap: Record<number, string>;
      statusFlatMapNameToId: Record<string, number>;
      statusIdToSequence: Record<number, number>;
      setStatusIdToSequence: (data: Record<number, number>) => void;
      setUser: (user: User) => void;
      setStatus: (status: Status[]) => void;
      setVerifiers: (verifier: Verifier[]) => void;
      setStatusFlatMap: (data: Record<number, string>) => void;
      setStatusFlatMapNameToId: (data: Record<string, number>) => void;
      clearUser: () => void;
}

export const useUserStore = create<UserState>((set) => ({
      user: null,
      status: null,
      verifiers: null,
      statusFlatMap: {},
      statusFlatMapNameToId: {},
      statusIdToSequence: {},
      setStatus: (status) => set({ status: status }),
      setVerifiers: (verifiers) => set({ verifiers: verifiers }),
      setUser: (user) => set({ user: user }),
      setStatusFlatMap: (data: Record<number, string>) => set({ statusFlatMap: data }),
      setStatusFlatMapNameToId: (data: Record<string, number>) => set({ statusFlatMapNameToId: data }),
      setStatusIdToSequence: (data: Record<number, number>) => set({ statusIdToSequence: data }),
      clearUser: () => set({ user: null }),
}));
